<div style="margin-bottom: 1em">
    <p-toolbar>
        <p-floatLabel variant="on">
            <p-select
                styleClass="w-12rem"
                [options]="groupsSelectItem"
                [filter]="false"
                appendTo="body"
                [autoDisplayFirst]="false"
                [(ngModel)]="groupForMultiUpdate"
            >
            </p-select>
            <label for="float-dd">Policy Group</label>
        </p-floatLabel>

        <button
            pButton
            pRipple
            type="button"
            class="p-button-secondary"
            label="Update"
            icon="pi pi-pencil"
            (click)="empMultiUpdate()"
            [disabled]="groupForMultiUpdate == null ? true : false"
        ></button>

        <div class="flex items-center">
            <p-checkbox
                *ngIf="companySettings?.length > 0"
                class="setting-checkbox"
                title="Checkbox controls whether QuickBooks employee accrual record is updated as policy conditions or met or changed."
                binary="true"
                [(ngModel)]="companySettings[0].SettingValue"
                (onChange)="onCheckboxChange($event)"
            ></p-checkbox>
            <label class="ml-2">Update QuickBooks during sync list</label>
        </div>

    </p-toolbar>
    <!-- <p-accordion>
        <p-accordionTab header="Multi Update" selected="true">

        </p-accordionTab>
    </p-accordion> -->
</div>

<p-table stripedRows #EmployeeTable
    [scrollable]="true"
    [style]="{ 'max-width': '100%' }"
    scrollHeight="flex"
    [value]="policyAssignment"
    editMode="row"
    [customSort]="true"
    (sortFunction)="customSort($event)"
    (onEditInit)="onEditInit($event)"
    (onRowEditSave)="onRowEditSave($event)"
    dataKey="EmployeeListID"
    [(selection)]="empSelection"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="10" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header>
        <tr>
            <th class="edit-cell"></th>
            <th class="select-cell">
                <p-tableHeaderCheckbox />
            </th>
            <th class="status-cell">
                <i
                    class="pi pi-exclamation-circle"
                    title="Status"
                ></i>
            </th>
            <th pSortableColumn="EmployeeName">
                Employee
                <p-sortIcon
                    field="EmployeeName"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                >
                </p-sortIcon>
                <p-columnFilter field="EmployeeName" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                            class="filter"
                            defaultLabel="Filter"
                            [options]="employeeFilterSelectItem"
                            [filter]="true"
                            appendTo="body"
                            styleClass="w-full"
                            [ngModel]="value"
                            (ngModelChange)="filter($event)"
                        >
                        </p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <th pSortableColumn="PolicyTitle">
                Policy Assigned
                <p-sortIcon
                    field="PolicyTitle"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                >
                </p-sortIcon>
                <p-columnFilter field="PolicyTitle" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                            class="filter"
                            defaultLabel="Filter"
                            [options]="policyFilterSelectItem"
                            [filter]="true"
                            appendTo="body"
                            styleClass="w-full"
                            [ngModel]="value"
                            (ngModelChange)="filter($event)"
                        >
                        </p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <th pSortableColumn="HireDate">
                Hire Date
                <p-sortIcon
                    field="HireDate"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                >
                </p-sortIcon>
            </th>
            <th pSortableColumn="YearsOfService">
                Yrs of Service
                <p-sortIcon
                    field="YearsOfService"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                >
                </p-sortIcon>
            </th>
            <th pSortableColumn="AccrualPeriod">
                Accrual Period
                <p-sortIcon
                    field="AccrualPeriod"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                >
                </p-sortIcon>
                <p-columnFilter field="AccrualPeriod" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                            class="filter"
                            defaultLabel="Filter"
                            [options]="accrualsFilterSelectItem"
                            [filter]="true"
                            appendTo="body"
                            styleClass="w-full"
                            [ngModel]="value"
                            (ngModelChange)="filter($event)"
                        >
                        </p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <th pSortableColumn="HoursAccrued">
                Accrual Value
                <p-sortIcon
                    field="HoursAccrued"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                >
                </p-sortIcon>
            </th>
            <th pSortableColumn="EffectiveDate">
                Policy Effective
                <p-sortIcon
                    field="EffectiveDate"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                >
                </p-sortIcon>
            </th>
            <th pSortableColumn="AdjustedServiceDate">
                Adjusted Service Date
                <p-sortIcon
                    field="AdjustedServiceDate"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                >
                </p-sortIcon>
            </th>
            <th pSortableColumn="EffectiveDateModified">
                Modified
                <p-sortIcon
                    field="EffectiveDate"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                >
                </p-sortIcon>
            </th>
            <th pSortableColumn="EffectiveDateModifiedBy">
                Modified By
                <p-sortIcon
                    field="EffectiveDateModifiedBy"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                >
                </p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template
        #body
        let-employee
        let-edit="editing"
        let-ri="rowIndex"
    >
        <tr [pEditableRow]="employee"
            data-id="row-{{ employee.EmployeeListID }}"
        >
            <td class="edit-cell">
                <button
                    *ngIf="
                        !edit &&
                        (!editing?.EmployeeListID ||
                            !editing?.EmployeeListID ===
                                employee?.EmployeeListID)
                    "
                    pButton
                    pRipple
                    type="button"
                    pInitEditableRow
                    icon="pi pi-pencil"
                    (click)="onRowEditInit(employee)"
                    class="p-button-rounded p-button-text"
                    title="Edit"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    pRipple
                    type="button"
                    pSaveEditableRow
                    icon="pi pi-check"
                    (click)="onRowEditSave(employee)"
                    class="p-button-rounded p-button-text p-button-success"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    pRipple
                    type="button"
                    pCancelEditableRow
                    icon="pi pi-times"
                    (click)="onRowEditCancel(employee)"
                    class="p-button-rounded p-button-text p-button-danger"
                ></button>
            </td>
            <td class="select-cell">
                <p-tableCheckbox [value]="employee"></p-tableCheckbox>
            </td>
            <td class="status-cell">
                <a (click)="onStatusClick(employee)">
                    <div>
                        <ef-status-icon
                            [status]="employee?.Status?.StatusCode"
                            [message]="employee?.Status?.Message"
                        ></ef-status-icon>
                    </div>
                </a>
            </td>
            <td>
                {{ employee.EmployeeName }}
            </td>
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <div *ngIf="this.groupsInTableSelectItem as items">
                            <ef-dropdown
                                [items]="items"
                                [rowData]="employee"
                                property="Groupid"
                            ></ef-dropdown>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ employee.PolicyTitle }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <td>
                <span *ngIf="employee.HireDate != null">
                    {{ moment(employee.HireDate).format('MM/DD/YYYY') }}
                </span>
            </td>
            <td>
                {{ employee.YearsOfService }}
            </td>
            <td>
                {{ employee.AccrualPeriod }}
            </td>
            <td
                [class.cell-highlight]="checkForOverrideMsg(employee)"

            >
                <div
                    *ngIf="employee.OverrideMsg != null"
                    [title]="employee.OverrideMsg"
                >
                    {{ employee.HoursAccrued }}
                </div>
                <div *ngIf="employee.OverrideMsg == null">
                    {{ employee.HoursAccrued }}
                </div>
            </td>
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <p-calendar
                            [(ngModel)]="employee.EffectiveDate"
                            appendTo="body"
                            [minDate]="userInfo.CurrentPayPeriodStart"
                            [monthNavigator]="true"
                            [yearNavigator]="true"
                            yearRange="2000:2030"
                        ></p-calendar>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <span *ngIf="employee.EffectiveDate != null">
                            {{
                                moment(employee.EffectiveDate).format(
                                    'MM/DD/YYYY'
                                )
                            }}
                        </span>
                    </ng-template>
                </p-cellEditor>
            </td>
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="isQBO" pTemplate="input">
                        <p-calendar
                            [(ngModel)]="employee.AdjustedServiceDate"
                            appendTo="body"
                            [monthNavigator]="true"
                            [yearNavigator]="true"
                            yearRange="2000:2030"
                        ></p-calendar>
                    </ng-template>
                    <ng-template *ngIf="!isQBO" pTemplate="input">
                        <span *ngIf="employee.AdjustedServiceDate != null">
                            {{
                                moment(employee.AdjustedServiceDate).format(
                                    'MM/DD/YYYY'
                                )
                            }}
                        </span>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <span *ngIf="employee.AdjustedServiceDate != null">
                            {{
                                moment(employee.AdjustedServiceDate).format(
                                    'MM/DD/YYYY'
                                )
                            }}
                        </span>
                    </ng-template>
                </p-cellEditor>
            </td>
            <td>
                <span *ngIf="employee.EffectiveDateModified != null">
                    {{
                        moment(employee.EffectiveDateModified).format(
                            'MM/DD/YYYY'
                        )
                    }}
                </span>
            </td>
            <td>
                <span *ngIf="employee.EffectiveDateModifiedBy != null">
                    {{ employee.EffectiveDateModifiedBy }}
                </span>
            </td>
        </tr>
    </ng-template>
</p-table>
